import { render } from "./BDLineChart.vue?vue&type=template&id=400fe3db&scoped=true"
import script from "./BDLineChart.vue?vue&type=script&lang=js"
export * from "./BDLineChart.vue?vue&type=script&lang=js"

import "./BDLineChart.vue?vue&type=style&index=0&id=400fe3db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400fe3db"]])

export default __exports__